/** THIS FILE IS AUTOMATICALLY GENERATED FROM : https://testapi.ashtrom.co.il/swagger/v1/swagger.json **/

import axios from "../axios"
import * as Ashtrom from "./AshtromInterfaces"

export const getAiChatGetToken = (locale?: string) =>
  axios.get<Ashtrom.StringResponseWrapper>(`/api/ai-chat/getToken`, {
    headers: { "X-Accept-Language": locale },
  })

export const getWebBmbyProjectsProjectId = (
  projectId: string,
  locale?: string
) =>
  axios.get<Ashtrom.ProjectDtoResponseWrapper>(
    `/web/bmby/projects/${projectId}`,
    { headers: { "X-Accept-Language": locale } }
  )

export const getWebBmbyAllProjects = (locale?: string) =>
  axios.get<Ashtrom.ProjectDtoListResponseWrapper>(`/web/bmby/allProjects`, {
    headers: { "X-Accept-Language": locale },
  })

export const getWebBmbyVersion = (locale?: string) =>
  axios.get<Ashtrom.StringResponseWrapper>(`/web/bmby/version`, {
    headers: { "X-Accept-Language": locale },
  })

export const postWebBmbyLead = (data: Ashtrom.LeadRequest, locale?: string) =>
  axios.post<Ashtrom.SendLeadResponseResponseWrapper>(`/web/bmby/lead`, data, {
    headers: { "X-Accept-Language": locale },
  })

export const getWebCareerJobsOrderId = (orderId: string, locale?: string) =>
  axios.get<Ashtrom.JobDtoResponseWrapper>(`/web/career/jobs/${orderId}`, {
    headers: { "X-Accept-Language": locale },
  })

export const postWebCareerJobsLobby = (
  data: Ashtrom.JobRequest,
  locale?: string
) =>
  axios.post<Ashtrom.JobsLobbyResponseResponseWrapper>(
    `/web/career/jobsLobby`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postWebCareerApply = (
  data: Ashtrom.ApplyRequest,
  locale?: string
) =>
  axios.post<Ashtrom.StringResponseWrapper>(`/web/career/apply`, data, {
    headers: { "X-Accept-Language": locale },
  })

export const getWebContactUsSubjectsCompanyId = (
  companyId: string,
  locale?: string
) =>
  axios.get<Ashtrom.Int32StringDictionaryResponseWrapper>(
    `/web/contactUs/subjects/${companyId}`,
    { headers: { "X-Accept-Language": locale } }
  )

export const postWebContactUsSendContactUs = (
  data: Ashtrom.SendContactUsFormRequest,
  locale?: string
) =>
  axios.post<Ashtrom.BooleanResponseWrapper>(
    `/web/contactUs/sendContactUs`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postWebContactUsSendDonationRequest = (
  formData: FormData,
  onUploadProgress?: (progressEvent: any) => void,
  locale?: string
) =>
  axios.post<Ashtrom.BooleanResponseWrapper>(
    `/web/contactUs/sendDonationRequest`,
    formData,
    {
      onUploadProgress,
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Accept-Language": locale,
      },
    }
  )

export const postWebContactUsSendToEmail = (
  data: Ashtrom.LeadToEmailRequest,
  locale?: string
) =>
  axios.post<Ashtrom.SendLeadResponseResponseWrapper>(
    `/web/contactUs/sendToEmail`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const getWebHostServices = (location: string, locale?: string) =>
  axios.get<Ashtrom.HostServiceResponseListResponseWrapper>(
    `/web/host/services`,
    { params: { location }, headers: { "X-Accept-Language": locale } }
  )

export const getWebHostResourcesSearch = (
  location: string,
  type: string,
  capacity: number /* int32 */,
  start_time: number /* int32 */,
  end_time: number /* int32 */,
  date: string,
  locale?: string
) =>
  axios.get<Ashtrom.HostResourceResponseListResponseWrapper>(
    `/web/host/resources/search`,
    {
      params: { location, type, capacity, start_time, end_time, date },
      headers: { "X-Accept-Language": locale },
    }
  )

export const getWebHostResourcesSlots = (
  room_id: number /* int32 */,
  dates: string[],
  slot_duration: number /* int32 */,
  locale?: string
) =>
  axios.get<Ashtrom.HostSlotsResponseResponseWrapper>(
    `/web/host/resources/slots`,
    {
      params: { room_id, dates, slot_duration },
      headers: { "X-Accept-Language": locale },
    }
  )

export const getWebHostResourcesId = (id: string, locale?: string) =>
  axios.get<Ashtrom.HostResourceResponseResponseWrapper>(
    `/web/host/resources/${id}`,
    { headers: { "X-Accept-Language": locale } }
  )

export const getWebHostValidateCoupon = (
  location: string,
  code: string,
  locale?: string
) =>
  axios.get<Ashtrom.HostCouponResponseResponseWrapper>(
    `/web/host/validate-coupon`,
    { params: { location, code }, headers: { "X-Accept-Language": locale } }
  )

export const postWebHostOrderCalculatePrice = (
  data: Ashtrom.HostCalculatePriceRequest,
  locale?: string
) =>
  axios.post<Ashtrom.HostCalculatePriceResponseResponseWrapper>(
    `/web/host/order/calculate-price`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postWebHostOrderCreate = (
  data: Ashtrom.HostCreateOrderRequest,
  locale?: string
) =>
  axios.post<Ashtrom.HostCreateOrderResponseResponseWrapper>(
    `/web/host/order/create`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const getWebPriorityProjectsProjectId = (
  projectId: string,
  locale?: string
) =>
  axios.get<Ashtrom.ProjectDtoResponseWrapper>(
    `/web/priority/projects/${projectId}`,
    { headers: { "X-Accept-Language": locale } }
  )

export const getWebPriorityAllEntitledProjects = (locale?: string) =>
  axios.get<Ashtrom.ProjectDtoListResponseWrapper>(
    `/web/priority/allEntitledProjects`,
    { headers: { "X-Accept-Language": locale } }
  )

export const getWebPriorityAllFreeMarketProjects = (locale?: string) =>
  axios.get<Ashtrom.ProjectDtoListResponseWrapper>(
    `/web/priority/allFreeMarketProjects`,
    { headers: { "X-Accept-Language": locale } }
  )

export const getWebPriorityAssetAssetNameDocuments = (
  assetName: string,
  locale?: string
) =>
  axios.get<Ashtrom.AssetDocumentsDtoResponseWrapper>(
    `/web/priority/asset/${assetName}/documents`,
    { headers: { "X-Accept-Language": locale } }
  )

export const getWebSearch = (
  s: string,
  lang: string,
  section: string,
  city: string,
  status: string,
  mode: string,
  pageSize: number /* int32 */,
  pageIndex: number /* int32 */,
  locale?: string
) =>
  axios.get<Ashtrom.SearchResponseResponseWrapper>(`/web/search`, {
    params: { s, lang, section, city, status, mode, pageSize, pageIndex },
    headers: { "X-Accept-Language": locale },
  })

export const getWebTaseStockBanner = (locale?: string) =>
  axios.get<Ashtrom.SlimStockDtoResponseWrapper>(`/web/tase/stockBanner`, {
    headers: { "X-Accept-Language": locale },
  })

export const getWebTaseGraphStock = (locale?: string) =>
  axios.get<Ashtrom.GraphStockResponseResponseWrapper>(`/web/tase/graphStock`, {
    headers: { "X-Accept-Language": locale },
  })

export const getWebTaseBondsStockType = (StockType: string, locale?: string) =>
  axios.get<Ashtrom.BondsTableResponseResponseWrapper>(
    `/web/tase/bonds/${StockType}`,
    { headers: { "X-Accept-Language": locale } }
  )

export const getWebTaseStockHolders = (locale?: string) =>
  axios.get<Ashtrom.StockHoldersResponseResponseWrapper>(
    `/web/tase/stockHolders`,
    { headers: { "X-Accept-Language": locale } }
  )

export const getTest = (locale?: string) =>
  axios.get<any>(`/api/test`, { headers: { "X-Accept-Language": locale } })

export const postWebTransactionsInitIframe = (
  data: Ashtrom.InitIframeTransactionRequest,
  locale?: string
) =>
  axios.post<Ashtrom.InitIframeTransactionResponseResponseWrapper>(
    `/web/transactions/init-iframe`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postWebTransactionsStatusUpdate = (
  formData: FormData,
  onUploadProgress?: (progressEvent: any) => void,
  locale?: string
) =>
  axios.post<Ashtrom.CompletePaymentResponse>(
    `/web/transactions/statusUpdate`,
    formData,
    {
      onUploadProgress,
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Accept-Language": locale,
      },
    }
  )

export const getWebTransactionsSuccessfulTransactionPage = (
  response: string,
  cField1: string,
  cField2: string,
  locale?: string
) =>
  axios.get<any>(`/web/transactions/successfulTransactionPage`, {
    params: { response, cField1, cField2 },
    headers: { "X-Accept-Language": locale },
  })
